<template>
  <div class="index">
    <mt-tabbar v-model="selected">
      <mt-tab-item :id="item.name" v-for="(item, index) in levelOneMenu" :key="index" @click.native="jump(item,index)">
        <img slot="icon" :src="`${baseUrl}icon/${item.url}.svg`">
        {{item.name}}
      </mt-tab-item>
    </mt-tabbar>
    <div class="content">
      <router-view/>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      selected: this.$route.query.selected === 1 ? '会诊' : '',
      levelOneMenu: [],
      userId: '',
      baseUrl: process.env.BASE_URL,
    }
  },
  created() {
    // alert(location.href)
    if (!this.$route.query.selected && localStorage.getItem('selected')) {
      this.selected = localStorage.getItem('selected')
    } else {
      this.selected = '会诊'
    }
    this.userId = this.GetQueryString('UserId')
    const username = this.GetQueryString('userName')
    const loginName = this.GetQueryString('LoginName')
    const hospitalId = this.GetQueryString('HospitalID')
    const hospitalName = this.GetQueryString('HospitalName')
    const code = this.GetQueryString("code")
    if (this.userId != null) {
      localStorage.setItem("UserId", this.userId)
      localStorage.setItem('HospitalID', hospitalId)
      localStorage.setItem('code', code)
      this.setCookie()
    } else {
      this.getUserMenu()
    }
  },
  methods: {
    // GetQueryString(paraName) {
    //   var url = document.location.toString();
    //   var arrObj = url.split("?");
    //   if (arrObj.length > 1) {
    //     var arrPara = arrObj[1].split("&");
    //     var arr;
    //     for (var i = 0; i < arrPara.length; i++) {
    //       arr = arrPara[i].split("=");
    //       if (arr != null && arr[0] == paraName) {
    //         return arr[1];
    //       }
    //     }
    //     return "";
    //   } else {
    //     return "";
    //   }
    // },
    // 获取浏览器参数
    GetQueryString(paraName) {
      let url = document.location.toString()
      let arrObj = url.split('?')
      if (arrObj.length > 1) {
        let arrPara = arrObj[1].split('&')
        let arr
        for (let i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split('=')
          if (arr != null && arr[0] == paraName) {
            return arr[1]
          }
        }
        return null
      } else {
        return null
      }
    },
    setCookie() {
      new Promise((resolve, reject) => {
        this.Axios.get('/api/WeChat/SetCookies?userID=' + this.userId).then(res => {
          if (res.data == true) {
            resolve(true)
          }     
        })
      }).then(res => {
        if (res == true) {
          setTimeout(() => {
            this.getUserMenu()
            localStorage.setItem('isLogin', true)
          }, 1000)
        }
      })
    },
    jump(val, index) {
      this.levelOneMenu.forEach((item, i) => {
        if (i === index) {
          item.url = item.value + '-checked'
        } else {
          item.url = item.value
        }
      })
      localStorage.setItem('selected', '')
      if (val.name == '视频') {
        this.$router.push({
          name: 'Video'
        });
      } else if (val.name == '会诊') {
        this.$router.push({
          name: 'Consultation'
        });
      } else if (val.name == '查房') {
        this.$router.push({
          name: 'WardRound'
        });
      } else if (val.name == '教育') {
        this.$router.push({
          name: 'Education'
        });
      }
    },
    getUserMenu() {
      const userId = localStorage.getItem('UserId')
      this.Axios.get('/api/User/GetUserJurisdiction/'+userId).then(res=>{
        // console.log(res.data)
        if(res.status === 200 && res.data.data != 'undefined'){
          this.levelOneMenu = res.data.data.filter(item => {
            return item.menuName === '远程会诊' || item.menuName === '协作查房' || item.menuName === '直播课程' || item.menuName === '在线课程'
          })
          // console.log(666, this.levelOneMenu)
          for (var item of this.levelOneMenu) {
            if (item.menuName == '远程会诊') {
              item.name = '会诊'
              item.value = 'group-consultation'
              item.url = 'group-consultation'
            } else if (item.menuName == '协作查房') {
              item.name = '查房'
              item.value = 'ward-round'
              item.url = 'ward-round'
            } else if (item.menuName == '直播课程') {
              item.name = '教育'
              item.value = 'education'
              item.url = 'education'
            } else {
              item.name = '视频'
              item.value = 'video'
              item.url = 'video'
            }  
          }
          this.levelOneMenu.forEach(item => {
            if (item.name === this.selected) {
              item.url = item.value + '-checked'
            } else {
              item.url = item.value
            }
          })
        }
      })
    }
  },
};
</script>

<style lang="less">
.index {
  height: 100%;
  overflow: hidden;
  // position: fixed;
  transform: scale(1.0);
  .content {
    height: 92%;
    border-bottom: 0;
    // border: 1px solid rebeccapurple;
  }
  .mint-tabbar {
    // border-top: 1px solid rebeccapurple;
    // border: 1px solid rebeccapurple;
    // height: 10%;
    // position: fixed;
    // position: relative;
    // z-index: 66;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 999;
  }
}
</style>
